import { tickerItems } from "@/mocks/siteData";

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="relative overflow-hidden bg-primary-950 text-accent-200 border-y-4 border-accent-500">
      <div className="flex items-center">
        <div className="z-10 flex items-center gap-2 px-4 md:px-5 py-2.5 bg-accent-500 text-primary-950 font-semibold text-xs md:text-sm whitespace-nowrap shrink-0">
          <i className="ri-flashlight-fill text-base w-4 h-4 flex items-center justify-center"></i>
          实时滚动
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {doubled.map((item, i) => (
              <span key={i} className="flex items-center gap-2 px-6 text-sm text-accent-100/90 whitespace-nowrap">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulseDot"></span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}